import React from 'react';
import BuildingIntro from './BuildingIntro';
import CapabilitiesTable from './CapabilitiesTable';
import EnterpriseConsiderations from './EnterpriseConsiderations';
import ImplementationSteps from './ImplementationSteps';
import StartBuilding from './StartBuilding';

const BuildingWithASI1 = () => {
  return (
    <section className="mb-16">
      <BuildingIntro />
      <CapabilitiesTable />
      <EnterpriseConsiderations />
      <ImplementationSteps />
      <StartBuilding />
    </section>
  );
};

export default BuildingWithASI1;
